module.exports = __webpack_public_path__ + "static/media/marginalia-circles.ba4c6539.png";